import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

import { Container as CommonContainer } from 'assets/Common/Layout';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};

  ${Media.lg`
  background: ${props =>
    props.theme.backgroundOnMobile || props.theme.background};
  `}
  ${Media.lg`
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Container = styled.div`
  ${CommonContainer}
`;

export const Box = styled.div`
  display: flex;
  /* width: 100%; */
  flex-wrap: wrap;
  margin: 0 -7px;

  ${Media.sm`
    justify-content: center;
  `}
`;

export const Item = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin: 2px;
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  cursor: pointer;

  ${Media.sm`
    width: 100%;
  `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
    `}
`;

export const ItemExternal = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin: 2px;
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  cursor: pointer;

  ${Media.sm`
    width: 100%;
  `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
    `}
`;

export const Text = styled.span`
  display: inline-block;
  margin: 2px;
  transition: 0.2s all;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;
